import { DataHubActions } from '../../dataHubActions';
import { BaseViewSchema } from '../baseViewSchema';
export class ViewBulkDrippingCreateSchema extends BaseViewSchema {
    constructor({ pages, modules, arrivedFrom }) {
        super({ arrivedFrom });
        Object.defineProperty(this, "action", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "pages", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "modules", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.action = DataHubActions.ViewBulkDrippingCreate;
        this.pages = pages;
        this.modules = modules;
    }
    getDataHubEventData() {
        return { ...super.prepare(), pages: this.pages, modules: this.modules };
    }
}
